class AjaxCollection {
    constructor() {
        /*=========================================
            =            ELEMENTS                    =
            =========================================*/

        this.section = document.getElementById("CollectionSection");

        if (!this.section) return;

        this.productsWrapper = document.getElementById("CollectionProducts");

        this.paginationWrapper = document.getElementById("CollectionPagination");

        this.filterForm = document.getElementById("CollectionFiltersForm");

        this.mobileFilterForm = document.getElementById("MobileCollectionFilters");

        this.sort = document.getElementById("CollectionSort");

        this.grid = document.getElementById("CollectionGrid");

        this.loading = false;

        this.init();
    }

    /*=========================================
      =            INIT                        =
      =========================================*/

    init() {
        this.bindFilters();

        this.bindPagination();

        this.bindSorting();

        this.initQuickAdd();

        this.initWishlist();

        this.initViewSwitcher();

        this.bindCartDrawerEvents();

        this.lazyImages();

        this.animateProducts();

        this.bindClearFilters();

        this.bindActiveFilters();

        window.addEventListener(
            "popstate",

            () => {
                this.render(
                    window.location.href,

                    false,
                );
            },
        );
    }

    /*=========================================
      =            REFRESH DOM                =
      =========================================*/

    refreshElements() {
        this.productsWrapper = document.getElementById("CollectionProducts");

        this.paginationWrapper = document.getElementById("CollectionPagination");

        this.filterForm = document.getElementById("CollectionFiltersForm");

        this.mobileFilterForm = document.getElementById("MobileCollectionFilters");

        this.sort = document.getElementById("CollectionSort");

        this.grid = document.getElementById("CollectionGrid");
    }

    /*=========================================
      =            AFTER AJAX                 =
      =========================================*/

    afterRender() {
        this.refreshElements();

        this.bindFilters();

        this.bindPagination();

        this.bindSorting();

        this.initQuickAdd();

        this.initWishlist();

        this.bindCartDrawerEvents();

        this.lazyImages();

        this.animateProducts();

        this.scrollToProducts();

        this.bindClearFilters();

        this.bindActiveFilters();
    }

    /*=========================================
      =            FILTER EVENTS               =
      =========================================*/

    bindFilters() {
        [this.filterForm, this.mobileFilterForm].forEach((form) => {
            if (!form) return;

            /* ==========================================
            CHECKBOX / RADIO
            Desktop = AJAX immediately
            Mobile = wait for Apply
            ========================================== */

            form
                .querySelectorAll(
                    'input[type="checkbox"], input[type="radio"]'
                )
                .forEach((input) => {

                    input.onchange = () => {

                        /* Mobile filter:
                            DO NOT submit automatically */
                        if (form === this.mobileFilterForm) {
                            return;
                        }

                        /* Desktop filter:
                            submit immediately */
                        this.submitFilters(form);
                    };
                });


            /* ==========================================
            PRICE INPUT
            ========================================== */

            form
                .querySelectorAll('input[type="number"]')
                .forEach((input) => {

                    input.onchange = () => {

                        if (form === this.mobileFilterForm) {
                            return;
                        }

                        this.submitFilters(form);
                    };
                });


            /* ==========================================
            FORM SUBMIT
            Only mobile Apply should submit manually
            ========================================== */

            form.onsubmit = (e) => {

                e.preventDefault();

                if (form === this.mobileFilterForm) {

                    /* Tell render() to close the drawer
                    after the AJAX request completes */

                    this.closeMobileFilterAfterRender = true;
                }

                this.submitFilters(form);
            };
        });
    }

    /*=========================================
      =            SORTING                     =
      =========================================*/

    bindSorting() {
        if (!this.sort) return;

        this.sort.onchange = () => {
            const url = new URL(window.location.href);

            url.searchParams.set(
                "sort_by",

                this.sort.value,
            );

            this.render(url.toString());
        };
    }

    /*=========================================
      =            PAGINATION                  =
      =========================================*/

    bindPagination() {
        if (!this.paginationWrapper) return;

        this.paginationWrapper

            .querySelectorAll("a")

            .forEach((link) => {
                link.onclick = (e) => {
                    e.preventDefault();

                    this.render(link.href);
                };
            });
    }

    /*=========================================
      =            SUBMIT FILTERS              =
      =========================================*/

    submitFilters(form) {
        const formData = new FormData(form);

        const params = new URLSearchParams();

        for (const [key, value] of formData.entries()) {
            if (value !== "") {
                params.append(key, value);
            }
        }

        if (this.sort) {
            params.set(
                "sort_by",

                this.sort.value,
            );
        }

        const url = `${window.location.pathname}?${params}`;

        this.render(url);
    }

    /*=========================================
      =            AJAX RENDER                 =
      =========================================*/

    async render(url, pushState = true) {
        if (this.loading) return;

        this.loading = true;

        this.showLoader();

        try {
            const response = await fetch(this.sectionURL(url));

            const htmlText = await response.text();

            const parser = new DOMParser();

            const html = parser.parseFromString(
                htmlText,

                "text/html",
            );

            this.replaceSection(
                "CollectionProducts",

                html,
            );

            this.replaceSection(
                "CollectionPagination",

                html,
            );

            this.replaceSection(
                "CollectionFiltersForm",

                html,
            );

            this.replaceSection(
                "MobileCollectionFilters",

                html,
            );

            this.replaceSection(
                "CollectionSort",

                html,
            );

            this.updateProductCount(html);

            if (pushState) {
                history.pushState(
                    {},

                    "",

                    url,
                );
            }

            this.afterRender();

            /* ==========================================
               CLOSE MOBILE FILTER ONLY AFTER APPLY
            ========================================== */

            if (this.closeMobileFilterAfterRender) {

                this.closeMobileFilterAfterRender = false;

                setTimeout(() => {
                    this.closeMobileFilter();
                }, 150);
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.hideLoader();

            this.loading = false;
        }
    }

    /*=========================================
      =            SECTION URL                 =
      =========================================*/

    sectionURL(url) {
        const separator = url.includes("?") ? "&" : "?";

        return url + separator + "section_id=main-collection";
    }

    /*=========================================
      =            REPLACE SECTION             =
      =========================================*/

    replaceSection(id, html) {
        const current = document.getElementById(id);

        const updated = html.getElementById(id);

        if (!current || !updated) return;

        current.replaceWith(updated);
    }

    /*=========================================
      =            PRODUCT COUNT              =
      =========================================*/

    updateProductCount(html) {
        const current = document.querySelector(".product-count");

        const updated = html.querySelector(".product-count");

        if (!current || !updated) return;

        current.innerHTML = updated.innerHTML;
    }

    /*=========================================
      =            LOADER                      =
      =========================================*/

    showLoader() {
        if (!this.productsWrapper) return;

        this.productsWrapper.classList.add("loading");
    }

    hideLoader() {
        if (!this.productsWrapper) return;

        this.productsWrapper.classList.remove("loading");
    }

    /*=========================================
      =            QUICK ADD                   =
      =========================================*/

    initQuickAdd() {
        document.querySelectorAll(".quick-add").forEach((button) => {
            button.onclick = async (e) => {
                e.preventDefault();

                if (button.classList.contains("loading")) return;

                button.classList.add("loading");

                const variantId = button.dataset.variantId;

                try {
                    const response = await fetch("/cart/add.js", {
                        method: "POST",

                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },

                        body: JSON.stringify({
                            id: variantId,
                            quantity: 1,
                        }),
                    });

                    if (!response.ok) {
                        throw await response.json();
                    }

                    await this.updateCart();

                    button.classList.add("added");

                    setTimeout(() => {
                        button.classList.remove("added");
                    }, 1500);
                } catch (error) {
                    console.error(error);

                    alert(error.description || "Unable to add product.");
                } finally {
                    button.classList.remove("loading");
                }
            };
        });
    }

    /*=========================================
      =            UPDATE CART                 =
      =========================================*/

    async updateCart() {
        const response = await fetch("/cart.js");

        const cart = await response.json();

        this.updateCartCount(cart);

        await this.refreshCartDrawer();
    }

    /*=========================================
      =            CART COUNT                  =
      =========================================*/

    updateCartCount(cart) {
        document
            .querySelectorAll(".cart-count, .header-cart-count")
            .forEach((item) => {
                item.textContent = cart.item_count;
            });
    }

    /*=========================================
      =            CART DRAWER                 =
      =========================================*/

    async refreshCartDrawer() {
        try {
            const response = await fetch("/?section_id=cart-drawer");

            const html = await response.text();

            const parser = new DOMParser();

            const doc = parser.parseFromString(
                html,

                "text/html",
            );

            const newDrawer = doc.querySelector("#CartDrawer");

            const currentDrawer = document.querySelector("#CartDrawer");

            if (newDrawer && currentDrawer) {
                currentDrawer.innerHTML = newDrawer.innerHTML;
            }

            this.bindCartDrawerEvents();

            this.openCartDrawer();
        } catch (error) {
            console.error(error);
        }
    }

    /*=========================================
      =            OPEN DRAWER                 =
      =========================================*/

    openCartDrawer() {
        const drawer = document.getElementById("CartDrawer");

        if (!drawer) return;

        bootstrap.Offcanvas.getOrCreateInstance(drawer)

            .show();
    }

    /*=========================================
      =            CLOSE DRAWER                =
      =========================================*/

    closeCartDrawer() {
        const drawer = document.getElementById("CartDrawer");

        if (!drawer) return;

        const instance = bootstrap.Offcanvas.getInstance(drawer);

        if (instance) {
            instance.hide();
        }
    }

    /*=========================================
      =            CART EVENTS                 =
      =========================================*/

    bindCartDrawerEvents() {
        document.querySelectorAll(".qty-plus").forEach((button) => {
            button.onclick = () => {
                this.changeQuantity(
                    button.dataset.key,

                    Number(button.dataset.quantity) + 1,
                );
            };
        });

        document.querySelectorAll(".qty-minus").forEach((button) => {
            button.onclick = () => {
                const quantity = Number(button.dataset.quantity) - 1;

                this.changeQuantity(
                    button.dataset.key,

                    quantity,
                );
            };
        });

        document.querySelectorAll(".remove-item").forEach((button) => {
            button.onclick = () => {
                this.changeQuantity(
                    button.dataset.key,

                    0,
                );
            };
        });
    }

    /*=========================================
      =            CHANGE QUANTITY             =
      =========================================*/

    async changeQuantity(key, quantity) {
        try {
            await fetch("/cart/change.js", {
                method: "POST",

                headers: {
                    "Content-Type": "application/json",

                    Accept: "application/json",
                },

                body: JSON.stringify({
                    id: key,

                    quantity: quantity,
                }),
            });

            await this.updateCart();
        } catch (error) {
            console.error(error);
        }
    }

    /*=========================================
      =            GRID / LIST VIEW            =
      =========================================*/

    initViewSwitcher() {
        const gridBtn = document.getElementById("GridViewBtn");

        const listBtn = document.getElementById("ListViewBtn");

        if (!gridBtn || !listBtn || !this.grid) return;

        const setView = (view) => {
            if (view === "list") {
                this.grid.classList.add("list-view");

                gridBtn.classList.remove("active");

                listBtn.classList.add("active");
            } else {
                this.grid.classList.remove("list-view");

                listBtn.classList.remove("active");

                gridBtn.classList.add("active");
            }

            localStorage.setItem(
                "collection-view",

                view,
            );
        };

        gridBtn.onclick = () => {
            setView("grid");
        };

        listBtn.onclick = () => {
            setView("list");
        };

        const saved = localStorage.getItem("collection-view");

        if (saved) {
            setView(saved);
        }
    }

    /*=========================================
      =            WISHLIST                    =
      =========================================*/

    initWishlist() {
        if (
            window.wishlist &&
            typeof window.wishlist.syncWishlistButtons === "function"
        ) {
            window.wishlist.syncWishlistButtons();
        }
    }

    /*=========================================
      =            PRODUCT ANIMATION           =
      =========================================*/

    animateProducts() {
        document

            .querySelectorAll(".product-card")

            .forEach((card, index) => {
                card.style.opacity = "0";

                card.style.transform = "translateY(20px)";

                setTimeout(() => {
                    card.style.transition = "all .35s ease";

                    card.style.opacity = "1";

                    card.style.transform = "translateY(0)";
                }, index * 50);
            });
    }

    /*=========================================
      =            LAZY IMAGES                 =
      =========================================*/

    lazyImages() {
        document

            .querySelectorAll("#CollectionProducts img")

            .forEach((image) => {
                image.loading = "lazy";

                image.decoding = "async";
            });
    }

    /*=========================================
      =            SCROLL TO GRID              =
      =========================================*/

    scrollToProducts() {
        if (!this.productsWrapper) return;

        window.scrollTo({
            top: this.productsWrapper.offsetTop - 120,

            behavior: "smooth",
        });
    }

    /*=========================================
      =            MOBILE FILTER               =
      =========================================*/

    closeMobileFilter() {

        const drawer = document.getElementById("mobileFilter");

        if (!drawer) return;

        let instance = bootstrap.Offcanvas.getInstance(drawer);

        if (!instance) {
            instance = bootstrap.Offcanvas.getOrCreateInstance(drawer);
        }

        instance.hide();
    }

    bindClearFilters() {

        const buttons = document.querySelectorAll(
            "#ClearFilters, .clear-filters"
        );

        if (!buttons.length) return;

        buttons.forEach((button) => {

            button.onclick = (e) => {

                e.preventDefault();
                e.stopPropagation();

                /* ==========================================
                   CLEAR ALL CHECKBOXES
                ========================================== */

                document
                    .querySelectorAll(
                        '#CollectionFiltersForm input[type="checkbox"],' +
                        '#CollectionFiltersForm input[type="radio"],' +
                        '#MobileCollectionFilters input[type="checkbox"],' +
                        '#MobileCollectionFilters input[type="radio"]'
                    )
                    .forEach((input) => {
                        input.checked = false;
                    });


                /* ==========================================
                   CLEAR NUMBER / PRICE INPUTS
                ========================================== */

                document
                    .querySelectorAll(
                        '#CollectionFiltersForm input[type="number"],' +
                        '#MobileCollectionFilters input[type="number"]'
                    )
                    .forEach((input) => {
                        input.value = "";
                    });


                /* ==========================================
                   RESET MOBILE FORM
                ========================================== */

                if (this.mobileFilterForm) {
                    this.mobileFilterForm.reset();
                }


                /* ==========================================
                   RESET DESKTOP FORM
                ========================================== */

                if (this.filterForm) {
                    this.filterForm.reset();
                }


                /* ==========================================
                   CLEAR URL FILTERS
                ========================================== */

                this.closeMobileFilterAfterRender = false;

                this.render(window.location.pathname);
            };
        });
    }

    bindActiveFilters() {
        document.querySelectorAll(".active-filter").forEach((link) => {
            link.onclick = (e) => {
                e.preventDefault();

                this.render(link.href);
            };
        });
    }
}

document.addEventListener(
    "DOMContentLoaded",

    () => {
        window.ajaxCollection = new AjaxCollection();
    },
);
